<template>
  <div id="landing" class="container-fluid">
    <div data-aos="fade-up"  data-aos-duration="1500" id="square" class="text-uppercase text-center">
      <h1>
        celebrando 10 años de trayectoria
      </h1>
      <a href="#nosotros" class="btn btn-default">conoce nuestra historia</a>
    </div>
  </div>
</template>

<script>

export default {

}
</script>

<style lang="scss" scoped>
@import '~varmix';

#landing{
  @include bgCover('~imgs/banner.png');
  background-position:center;
  background-repeat:no-repeat;
  background-size:cover;
  position: relative;
  height: 1000px;
  height: 100vh;
  &:after{
    content: '\A';
    position: absolute;
    width: 100%; height:100%;
    top:0; left:0;
    background:rgba(0,0,0,0.0);
    opacity: 1;
    transition: all 1s;
    -webkit-transition: all 1s;
   @include tablet{
        background:none;
      }
  }
  #square{
    z-index: 1;
    font-family: bebas;
    position: absolute;
    margin: 300px 10%;
    padding: 20px;
    height: 150px;
    width: 400px;
    background-color: rgba(255,255,255, 0.3);
    @include cMax(520px){
      width: 75%;
      position: relative;
      margin: 0 auto;
      top: 40%;
      h1{
        font-size: 30px;
      }
    }

    h1{
      text-shadow: 2px 2px rgba(0,0,0,.5);
      color: white;
    }
    a{
      background-color: $red;
      color: white;
      border-color: white;
      font-family: bebas;
      font-size: 20px;
      height: 50px;
      padding-top: 10px;
      &:hover{
        background-color: $dark-red;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Landing.vue?32dd8c96